import { ServiceStatus } from '../../_generated/api/structure'
import { getPropertyValue } from '../../tools/dom/css-properties'
import t from '../../tools/t'
import { Chip } from './pure/chips'

export default function ServiceWindowStatus({ status }: { status: ServiceStatus }) {
    const labels = {
        active: t('service_window_active'),
        overdue: t('service_window_overdue'),
        done: t('service_window_done'),
    }
    const colors = { active: '--success-color', overdue: '--danger-color', done: '--info-color' }
    return <Chip label={labels[status]} color={getPropertyValue(colors[status])} />
}
